export default () => ({
  currentClinicalProfile: undefined,
  healthMeasurements: [],
  healthMeasurementTypes: [],
  healthMeasurementsTableData: undefined
})
